import { useOutletContext } from 'react-router-dom'

import { TrainingsSession } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { UploadCertificate } from 'modules/trainings/components/MyTrainings/UploadCertificate'

const EmployeeCertificatesUploadModal = () => {
  const { navigation } = useNavigation()
  const { employeeId, employeeAccessId, session } = useOutletContext<{
    employeeId: number
    employeeAccessId: number
    session: TrainingsSession
  }>()
  return (
    <UploadCertificate
      navigateBackTo={navigation.employees.id.training.nextSession.fullPath({
        id: employeeId,
        sessionId: session.id,
      })}
      accessId={employeeAccessId}
    />
  )
}

export default EmployeeCertificatesUploadModal
